import 'zone.js/dist/zone';
import '@popperjs/core';
import 'bootstrap';
import './polyfills'

document.addEventListener('DOMContentLoaded', () => {
	// code split allows the loading screen to appear much faster
	import('./init.angular').then(init => init.startApp());
});
